import { styled } from "@mui/material/styles";
import NotFound from "../../../assets/images/notfound.gif";

const PageMain = styled("section")(({ theme }) => ({
  padding: "40px 0",
  background: "#fff",
  "& .four_zero_four_bg": {
    backgroundImage: `url(${NotFound})`,
    backgroundPosition: "50%",
    backgroundRepeat: "no-repeat",
    height: "400px",
  },
  "& h2": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "20px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "20px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& a": {
    marginTop: "10px",
    background: "#E2E2E2",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    textTransform: "capitalize",
    padding: "10px 35px",
    borderRadius: "0px",
    boxShadow: "none",
    "&:hover": { background: "#E2E2E2", color: "#0B0B0B" },
  },
}));

export { PageMain };
